// Minimal I18n translations for JavaScript
// Only includes translations actually used in JS controllers

const translations = {
  en: {
    artists: {
      no_artists_found: "No artists found",
      add_new_artist: "+ Add a New Artist"
    },
    albums: {
      save_unpublished_continue: "Save Unpublished and Continue",
      edit: {
        saving: "Saving...",
        validation: {
          album_artwork_required: "Album Artwork is required",
          errors_one: "There is %{count} error with your submission",
          errors_other: "There are %{count} errors with your submission",
          is_required: "%{field} is required",
          live_date_before_original: "Live Date can't be earlier than Original Release Date",
          primary_artist_required: "At least one primary artist must be present in the album",
          fields: {
            album_title: "Album Title",
            c_line_copyright: "C-Line Copyright",
            c_line_year: "C-Line Copyright Year",
            label_name: "Label Name",
            live_date: "Live Date",
            original_release_date: "Original Release Date",
            p_line_copyright: "P-Line Copyright",
            p_line_year: "P-Line Copyright Year",
            primary_genre: "Primary Genre"
          }
        }
      },
      tracks: {
        actions: "Actions",
        add_lyrics: "Add Lyrics...",
        audio_too_short: "'%{filename}' must be at least %{minimum} seconds long. Your file is %{duration} second(s)",
        click_to_browse: "or click to browse - WAV, FLAC",
        click_to_browse_files: "or click to browse files - WAV, FLAC",
        confirm_delete_track: "Are you sure you want to delete \"%{title}\"?",
        drag_audio_files_here: "Drag Audio Files Here",
        duration: "Duration",
        edit_lyrics: "Edit Lyrics...",
        failed_delete_audio: "Failed to delete audio file",
        failed_delete_track: "Failed to delete track",
        failed_save_order: "Failed to save track order",
        failed_update_track: "Failed to update track",
        failed_upload: "Failed to upload file",
        failed_validate: "Failed to validate tracks",
        file: "File",
        network_error: "Network error. Please try again.",
        no_file: "No file provided",
        select_wav_flac: "Please select WAV or FLAC files",
        server_error: "Server error. Please try again.",
        title: "Title",
        track: "Track",
        track_id_missing: "Track ID is missing",
        track_listing: "Track Listing",
        track_updated_successfully: "Track updated successfully",
        upload_additional_tracks: "Upload additional tracks",
        uploading: "Uploading...",
        uploading_file: "Uploading %{filename}...",
        uploading_file_progress: "Uploading %{filename} (%{current} of %{total})...",
        validation_errors_one: "There is %{count} validation error with your tracks",
        validation_errors_other: "There are %{count} validation errors with your tracks"
      }
    }
  },
  es: {
    artists: {
      no_artists_found: "No se encontraron artistas",
      add_new_artist: "+ Agregar Nuevo Artista"
    },
    albums: {
      save_unpublished_continue: "Guardar sin Publicar y Continuar",
      edit: {
        saving: "Guardando...",
        validation: {
          album_artwork_required: "La portada del album es requerida",
          errors_one: "Hay %{count} error en tu envio",
          errors_other: "Hay %{count} errores en tu envio",
          is_required: "%{field} es requerido",
          live_date_before_original: "La Fecha de Publicacion no puede ser anterior a la Fecha de Lanzamiento Original",
          primary_artist_required: "Debe haber al menos un artista principal en el album",
          fields: {
            album_title: "Titulo del Album",
            c_line_copyright: "Copyright C-Line",
            c_line_year: "Ano de Copyright C-Line",
            label_name: "Nombre del Sello",
            live_date: "Fecha de Publicacion",
            original_release_date: "Fecha de Lanzamiento Original",
            p_line_copyright: "Copyright P-Line",
            p_line_year: "Ano de Copyright P-Line",
            primary_genre: "Genero Principal"
          }
        }
      },
      tracks: {
        actions: "Acciones",
        add_lyrics: "Agregar Letras...",
        audio_too_short: "'%{filename}' debe tener al menos %{minimum} segundos de duracion. Tu archivo tiene %{duration} segundo(s)",
        click_to_browse: "o haz clic para explorar - WAV, FLAC",
        click_to_browse_files: "o haz clic para explorar archivos - WAV, FLAC",
        confirm_delete_track: "Estas seguro de que quieres eliminar \"%{title}\"?",
        drag_audio_files_here: "Arrastra Archivos de Audio Aqui",
        duration: "Duracion",
        edit_lyrics: "Editar Letras...",
        failed_delete_audio: "Error al eliminar el archivo de audio",
        failed_delete_track: "Error al eliminar la cancion",
        failed_save_order: "Error al guardar el orden de las canciones",
        failed_update_track: "Error al actualizar la cancion",
        failed_upload: "Error al subir el archivo",
        failed_validate: "Error al validar las canciones",
        file: "Archivo",
        network_error: "Error de red. Por favor intenta de nuevo.",
        no_file: "No se proporciono ningun archivo",
        select_wav_flac: "Por favor selecciona archivos WAV o FLAC",
        server_error: "Error del servidor. Por favor intenta de nuevo.",
        title: "Titulo",
        track: "Cancion",
        track_id_missing: "Falta el ID de la cancion",
        track_listing: "Lista de Canciones",
        track_updated_successfully: "Cancion actualizada exitosamente",
        upload_additional_tracks: "Subir canciones adicionales",
        uploading: "Subiendo...",
        uploading_file: "Subiendo %{filename}...",
        uploading_file_progress: "Subiendo %{filename} (%{current} de %{total})...",
        validation_errors_one: "Hay %{count} error de validacion en tus canciones",
        validation_errors_other: "Hay %{count} errores de validacion en tus canciones"
      }
    }
  }
}

export default translations
